(() => {
      window.LandingScrollReveals?.dispose();
      const revealSections = document.querySelectorAll(".js-scroll-reveal");
      const cardGroups = document.querySelectorAll(".js-card-reveal");
      if (!revealSections.length && !cardGroups.length) {
        return;
      }

      const reduced = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches
        || document.documentElement.dataset.reduceMotion === "true";
      if (reduced || !("IntersectionObserver" in window)) {
        revealSections.forEach((section) => section.classList.add("is-visible"));
        cardGroups.forEach((group) => group.classList.add("is-visible"));
        return;
      }

      const compactReveal = window.matchMedia(
        "(max-width: 720px), (max-height: 500px) and (pointer: coarse)"
      ).matches;

      const sectionObserver = new IntersectionObserver((entries, revealObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      }, {
        threshold: compactReveal ? 0.08 : 0.18,
        rootMargin: compactReveal ? "0px 0px -4% 0px" : "0px 0px -12% 0px"
      });

      const cardObserver = new IntersectionObserver((entries, revealObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.add("is-visible");
          revealObserver.unobserve(entry.target);
        });
      }, {
        threshold: compactReveal ? 0.08 : 0.22,
        rootMargin: compactReveal ? "0px 0px -4% 0px" : "0px 0px -8% 0px"
      });

      revealSections.forEach((section) => sectionObserver.observe(section));
      cardGroups.forEach((group) => cardObserver.observe(group));
      window.LandingScrollReveals = {dispose(){sectionObserver.disconnect();cardObserver.disconnect();}};
    })();
  
